import { render, staticRenderFns } from "./scoreboard_mini.vue?vue&type=template&id=1c24e530&"
import script from "./scoreboard_mini.vue?vue&type=script&lang=js&"
export * from "./scoreboard_mini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventTime: require('/var/web/bet777.es/components/event_time.vue').default})
